module.exports = __webpack_public_path__ + "static/media/m-caoft.977caeb7.jpg";